<script>
  // import { useLocation } from "svelte-routing";
  import {
    LINK_DONATE,
    LINK_TERMS,
    PATH_DONATE,
    PATH_TERMS,
  } from "../util/constants";
  import ExternalLink from "./ExternalLink.svelte";
  import LinkButton from "./LinkButton.svelte";
  // import { onMount } from "svelte";

  // let curPath = "/";
  // const locationStore = useLocation();
  // const unsub = locationStore.subscribe((loc) => {
  //   curPath = loc ? loc.pathname : "/";
  // });
  // onMount(() => {
  //   return unsub;
  // });
</script>

<footer>
  <div class="left">
    <LinkButton to={PATH_TERMS}>Terms & Conditions</LinkButton>
    <LinkButton to={PATH_DONATE}>Other Ways to Donate</LinkButton>
  </div>
  <div class="right">
    <p>
      a project by <ExternalLink href="https://mattdesl.com/"
        >@mattdesl</ExternalLink
      >
    </p>
  </div>
</footer>

<style>
  footer {
    width: 100%;
    padding: var(--main-gutter);
    --vert-pad: var(--main-gutter-vertical-clamped);
    padding-top: var(--vert-pad);
    padding-bottom: var(--vert-pad);
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-top: 1px solid black;
  }
  footer p {
    margin: 0;
    padding: 0;
  }
  .left {
    font-size: 12px;
    gap: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  @media screen and (max-width: 720px) {
    footer {
      display: column;
      gap: 20px;
      flex-wrap: wrap;
    }
    .left {
      width: 100%;
      justify-content: space-between;
    }
  }
</style>
